import { InformationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import type { FixedNewsletter } from '../../../@types/Newsletter';
import Popup from '../Popup/Popup.module';
import PreviewViewer from '../PreviewViewer/PreviewViewer.module';

interface TemplateSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  newsletter: FixedNewsletter;
  onTemplateSelect: (newsletter: FixedNewsletter, templateName: string) => void;
}

function TemplateSelector({ isOpen, onClose, newsletter, onTemplateSelect }: TemplateSelectorProps) {
  const handleTemplateClick = (templateName: string) => {
    onTemplateSelect(newsletter, templateName);
  };

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      title={`Sélectionner un template - ${newsletter.title}`}
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          Cette newsletter dispose de plusieurs templates. Choisissez celui que vous souhaitez consulter :
        </p>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {newsletter.templates.map((template) => (
            <div
              key={template.name}
              className="cursor-pointer rounded-lg border p-4 transition-colors hover:border-blue-300 hover:bg-gray-50"
              onClick={() => handleTemplateClick(template.name)}
            >
              <div className="flex flex-col items-center">
                {template.pageCount > 0 ? (
                  <PreviewViewer
                    date={newsletter.date}
                    slug={newsletter.slug}
                    pageCount={template.pageCount}
                    templateName={template.name}
                    className="mb-3 h-[800px] w-full"
                    showNavigation={true}
                  />
                ) : (
                  <div className="mb-3 flex h-48 w-full items-center justify-center rounded bg-gray-200">
                    <InformationCircleIcon className="h-12 w-12 text-gray-400" />
                    <span className="ml-2 text-gray-500">Pas d'aperçu</span>
                  </div>
                )}
                <h3 className="text-center font-medium text-gray-800">{template.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Popup>
  );
}

export default TemplateSelector; 